import { isEmpty, last } from 'lodash/fp'
import z, { ZodIssue } from 'zod'

const FormSchema = z.object({
  No1: z.string({ message: "必須です" }).min(1, "必須です"),
  No2: z.enum(['男性', '女性', 'その他'], { message: "必須です" }),
  No3: z.enum(['カテエネ', 'チラシ', '友人', 'その他'], { message: "必須です" }),
  No4: z.array(z.enum(['同意する']), { message: "必須です" }).refine((data) => !isEmpty(data), "必須です"),
})

const CrossCheckSchema = z.object({
  No1: z.string().optional(),
  No2: z.enum(['男性', '女性', 'その他']).optional(),
  No3: z.enum(['カテエネ', 'チラシ', '友人', 'その他']).optional(),
  No4: z.array(z.enum(['同意する'])).optional()
}).superRefine((data, ctx) => {
})

export const FormInputSchema = z.intersection(FormSchema, CrossCheckSchema)

const adjustIssue = (issue: ZodIssue, data: any): any => {
  const { path } = issue
  let resultItem = data
  for (const item of path.slice(0, -1)) {
    resultItem = resultItem[item]
  }
  resultItem[last(path) as string] = ''
  return data
}

export const adjustData = (issues: ZodIssue[], data: any): any => {
  let result = data
  for (const issue of issues) {
    const { code } = issue
    if (code === 'invalid_union') {
      const { unionErrors } = issue
      for (const unionError of unionErrors) {
        const { issues } = unionError
        for (const issue of issues) {
          result = adjustIssue(issue, result)
        }
      }
    }
    if (code === 'invalid_type') {
      result = adjustIssue(issue, result)
    }
  }
  return result
}
